import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import Swal from 'sweetalert2';
import {AccessControlService} from 'src/app/services/access-control.service';
import {ClipboardService} from 'ngx-clipboard';
import {MatPaginator, MatSort} from '@angular/material';
import {ToastrService} from 'ngx-toastr';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {NgForm} from '@angular/forms';
import {ACCOUNTTYPES} from '../../model/types/Types';
import {ClientListingDataSource} from './client-listing.datasource';
import {fromEvent} from 'rxjs';
import {tap} from 'rxjs/operators';


@Component({
  selector: 'app-client-listing',
  templateUrl: './client-listing.component.html',
  styleUrls: ['./client-listing.component.css']
})
export class ClientListingComponent implements OnInit {
  dataSource: any;
  is_copied = false;
  displayedColumns: string[] = ['organization_name', '_id', 'username', 'phone', 'Actions'];
  clients: Array<string>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('input') input: ElementRef;
  modelRef: BsModalRef;
  cloneModal: {
    reference_client: string, selectedApps: [],
    options: { roles: boolean, permissions: boolean }, name: string, tenant: string,
    username: string, password: string, accountType: ACCOUNTTYPES, existingUsername: string
  };
  selectedClientApps = [];
  dropdownSettings = {
    singleSelection: false,
    idField: '_id',
    textField: 'application_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: false
  };
  showCloneAdditionalDetails = false;
  tenant: string = localStorage.getItem('org_id');
  isSaved = false;
  isLoading: boolean;
  defaultPageNumber = 1;
  defaultPageSize = 10;
  isDisabled: any | boolean;

  constructor(
    private accessControlService: AccessControlService,
    private toastrService: ToastrService,
    private modalService: BsModalService,
    private authService: AuthService,
    private _clipboardService: ClipboardService,
  ) {
  }

  ngOnInit() {
    // this.populateGrid();
    this.dataSource = new ClientListingDataSource(this.accessControlService);
    this.dataSource.getOrganizationClients(this.tenant, this.defaultPageNumber, this.defaultPageSize);
  }

  populateGrid() {
    const orgId = this.tenant;
    this.accessControlService.getOrganizationClients(orgId, 1, Number.MAX_SAFE_INTEGER).subscribe((response: any) => {
      if (!response.error) {
        console.log(response);
        this.clients = response.data;

      }
    }, error => {
      this.isLoading = false;
    });
  }

  ngAfterViewInit(): void {
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        tap((value: any) => {
          if (value.code == 'Enter' || value.target.value == '') {
            this.paginator.pageIndex = 0;
            this.listOrgClients();
          }
        })
      )
      .subscribe();
    this.sort.sortChange
      .subscribe((sort) => {
        this.defaultPageNumber = 1;
        this.paginator.pageIndex = 0;
        this.listOrgClients();
      });
    this.paginator.page.pipe(
      tap(() => {
        this.listOrgClients();
      })
    ).subscribe();
  }

  listOrgClients() {
    const pageNumber = this.paginator.pageIndex + 1;
    const pageSize = this.paginator.pageSize > this.defaultPageSize ? this.paginator.pageSize : this.defaultPageSize;
    this.dataSource.getOrganizationClients(this.tenant, pageNumber, pageSize, this.sort.active, this.sort.direction, this.input.nativeElement.value);

  }

  delete(clientId: any) {
    Swal({
      title: 'Are you sure you want to delete this client?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.accessControlService.deleteClient(clientId, this.tenant).subscribe((res: any) => {
          if (!res.error) {
            this.toastrService.success(res.message);
            // this.populateGrid();
            this.listOrgClients();
          } else {
            this.toastrService.info(res.message);

          }
        }, error => {
          this.toastrService.error(error);

        });
      }
    });
  }

  openModal(template: TemplateRef<any>) {
    this.populateGrid();
    const config = {backdrop: true, ignoreBackdropClick: true};
    this.showCloneAdditionalDetails = false;
    this.cloneModal = {
      options: {roles: true, permissions: true},
      selectedApps: [],
      reference_client: null,
      name: '',
      tenant: this.tenant,
      username: '',
      password: '',
      accountType: 'NEW',
      existingUsername: null
    };
    this.modelRef = this.modalService.show(template, config);
  }

  onClientChange(event) {
    debugger;
    this.accessControlService.getClient(event.target.value, localStorage.getItem('org_id')).subscribe((res: any) => {
      if (!res.error) {
        this.selectedClientApps = res.data.applications;
      }
      this.cloneModal.selectedApps = <any>this.selectedClientApps;
      this.showCloneAdditionalDetails = true;
    }, error => {
      this.toastrService.error(error);
      this.showCloneAdditionalDetails = false;
    });
  }

  onCloneCreation(cloneForm: NgForm) {
    this.isSaved = true;
    this.isDisabled = true;
    this.authService.createClientClone(this.cloneModal).subscribe((res: any) => {
        if (!res.error) {
          this.toastrService.success(res.message);
          this.modelRef.hide();
          // this.populateGrid()
          this.listOrgClients();
          this.isSaved = false;
        } else {
          this.toastrService.error(res.message);
          this.isSaved = false;
        }
        this.isDisabled = false;
      },
      error => {
        this.toastrService.error(error.error);
        this.isSaved = false;
        this.isDisabled = false;
      });
  }

  copyToClipboard(action) {
    this.is_copied = this._clipboardService.copyFromContent(action);
    setTimeout(() => {
      this.is_copied = false;
    }, 700);
  }

  closeAlert() {
    this.is_copied = false;
  }


}
